module.exports = __webpack_public_path__ + "img/kim-happy.71ec776a.svg";